<template>
  <li class="nav-item">
    <router-link
      :to="to"
      :class="{ 'active': isActive }"
      class="nav-link">{{ label }}</router-link>
  </li>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.$route.fullPath === this.$router.resolve(this.to).href;
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  background: $light !important;
  color: $link-color !important;
}

.nav-item {
  min-width: 10rem;
}
</style>
